<!--
 * @Author: 黄悦凯 huangyuekai@jafron.com
 * @Date: 2025-11-26 19:54:25
 * @LastEditors: 黄悦凯 huangyuekai@jafron.com
 * @LastEditTime: 2025-11-26 19:54:40
 * @FilePath: \to-consumer-h5\src\views\clockIn\checkIn\detail.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
    <div class="card" v-if="item">
      <h3 style="margin-top: 0;font-size: 16px">打卡详情</h3>

      <p><strong>姓名：</strong>{{ item.user?.name || '-' }}</p>
      <p><strong>部门：</strong>{{ item.user?.dept || '-' }}</p>
      <p><strong>时间：</strong>{{ formatTime(item.created_at) }}</p>
      <p v-if="item.note"><strong>说明：</strong>{{ item.note }}</p>

      <div class="img-grid" style="margin-top:12px">
        <img v-for="(u,i) in item.image_urls" :key="i" :src="u" />
      </div>

      <div style="margin-top:16px">
        <router-link to="/checkin" class="button">返回</router-link>
      </div>
    </div>

    <div class="card" v-else>
      <div v-if="loading" class="muted">加载中...</div>
      <div v-else>暂无对应的打卡记录</div>
      <div style="margin-top:16px">
        <router-link to="/checkin" class="button ghost">返回</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { toast } from '@/util/toast'
import { getCheckinDetail } from '../api/checkin'

export default {
  name: "CheckinDetail",

  data() {
    return {
      item: null,
      loading: false
    }
  },

  created() {
    this.fetchDetail()
  },

  methods: {
    async fetchDetail() {
      try {
        this.loading = true
        const id = this.$route.params.id
        this.item = await getCheckinDetail(id)
      } catch (err) {
        console.error(err)
        toast(err.message || '加载打卡详情失败')
      } finally {
        this.loading = false
      }
    },
    formatTime(iso) {
      if (!iso) return '-'
      try {
        return new Date(iso).toLocaleString()
      } catch (e) {
        return iso
      }
    }
  }
}
</script>

<style scoped>
.muted {
  color: var(--muted);
  font-size: 14px;
}
</style>
